<template>
  <div v-if="!busy">
    <div class="container-fluid">
      <div v-if="totalProgressPct > 0" class="row">
        <div class="col-2">
          <h6 class="mb-0">{{ $t('Create.uploading') }}</h6>
          <small>({{ $t('BasicUploader.total-bytes') }}: {{ totalUploadedBytes }})</small>
        </div>
        <div class="col-9">
          <b-progress height="2.6rem" :max="100" :value="totalProgressPct" show-progress animated></b-progress>
        </div>
      </div>
    </div>

    <vue-clip
      :options="options"
      :on-sending="onSending"
      :on-queue-complete="onQueueComplete"
      :on-total-progress="onTotalProgress"
      class="p-5 bg-light rounded text-center"
    >
      <template v-slot:clip-uploader-action>
        <div>
          <div class="dz-message mt-3" style="cursor: pointer;">
            <h5>{{ message || $t('click-or-drag-and-drop-to-upload-single-multiple-files-as-supporting-attachments') }}</h5>
          </div>
        </div>
      </template>

      <template v-slot:clip-uploader-body="props">
        <!--Shows attachment preview only while uploading-->
        <div v-if="totalProgressPct != 0 && !uploadFinished">
          <div v-for="(file, index) in props.files" :key="index">
            <img :src="file.dataUrl" />
            {{ file.name }} {{ file.status }}
          </div>
        </div>
      </template>
    </vue-clip>
  </div>
</template>
<script>
import Vue from 'vue';
import VueClip from 'vue-clip';

Vue.use(VueClip);
export default {
  props: {
    maxFiles: {
      type: Number,
      default: 10,
    },
    maxFilesize: {
      type: Number,
      default: 500,
    },
    message: {
      type: String,
      default: null,
    },
    acceptedFiles: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      // status / UI fields
      busy: true,
      totalProgressPct: 0,
      totalUploadedBytes: 0,
      files: [],
      s3Params: {},
      options: {}, // uploader options
      uploadFinished: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * Initialize the uploader, get the s3 upload params
     *
     */
    init() {
      this.busy = true;
      this.$http
        .post('s3/upload-params')
        .then(resp => {
          this.setupUploadForm(resp.data);
          // upload seutp is done!
          this.busy = false;
        })
        .catch(err => {
          this.$bvModal.msgBoxOk(this.$t('CreateMediaWithoutCollection.s3-upload-initialization-failed-please-check-console-for-details-or-refresh-the-page-to-try-again'));
          console.log('get s3 upload params failed', err);
          this.busy = false;
        });
    },
    setupUploadForm(s3) {
      // see option documentation here: https://github.com/thetutlage/vue-clip
      this.options = {
        url: s3.formAttributes.action,
        maxFilesize: this.maxFilesize || 500, // 500 MB
        autoProcessQueue: true,
        maxFiles: this.maxFiles || 10,
      };
      if (this.acceptedFiles) this.options.acceptedFiles = this.acceptedFiles;

      this.s3Params = s3;
    },
    onTotalProgress(progress, totalUploadedBytes) {
      this.totalProgressPct = progress;
      this.totalUploadedBytes = totalUploadedBytes;
    },
    onQueueComplete() {
      this.processFiles();
    },
    /**
     * Files are uploaded, this method will now create the necessary network media items using our API
     */
    processFiles() {
      if (this.files.length == 0) {
        // most likely the file is too big
        var msg = this.$t('network.error.no_files_uploaded');
        this.$bvModal.msgBoxOk(msg);
      } else {
        this.$emit('file-upload-complete', this.files);
        this.totalProgressPct = 0;
        this.uploadFinished = true;
        this.$swal.fire({
          icon: 'success',
          title: this.files.length == 1 ? this.$t('attachment-uploaded-succesfully') : this.$t('attachments-uploaded-succesfully'),
        });
      }
    },
    /**
     * Before sending a file, attach the s3 required parameters
     */
    onSending(file, xhr, formData) {
      var fullPath;
      // if a full path is set
      if ('fullPath' in file._file && file._file.fullPath) {
        fullPath = file._file.fullPath;
      } else {
        // probably a single file upload, no need for the path info
        fullPath = file._file.name;
      }
      var properPath = this.s3Params.uploadPathPrefix + '/' + fullPath;

      // update formData before the file is uploaded
      for (let key in this.s3Params.formInputs) {
        var value = this.s3Params.formInputs[key];
        if (key == 'key') value = properPath; // use the proper path calculated (in case its a full folder upload)

        formData.append(key, value);
      }
      this.files.push({
        name: file.name,
        size: file._file.size,
        fullPath: properPath,
      });
    },
  },
};
</script>
